import { render } from "./SelectDicoSetting.vue?vue&type=template&id=72ad85b5"
import script from "./SelectDicoSetting.vue?vue&type=script&lang=js"
export * from "./SelectDicoSetting.vue?vue&type=script&lang=js"

import "./SelectDicoSetting.vue?vue&type=style&index=0&id=72ad85b5&lang=css"

import exportComponent from "D:\\dev\\DiagDev-clean\\Projets autres\\AdminWSInterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__